import React from 'react';

const HomeIcon = () => {
  return (
    <svg viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M2.89001 9.99866L1.4132 11.4755L0 10.0623L9.47699 0.58529C10.2574 -0.195097 11.5226 -0.195097 12.303 0.58529L21.78 10.0623L20.3668 11.4755L18.89 9.99869V18C18.89 19.1046 17.9946 20 16.89 20H4.89001C3.78545 20 2.89001 19.1046 2.89001 18V9.99866ZM4.88867 8L10.89 1.99867L16.8913 8H16.89V18H4.89001V8H4.88867Z" fill="currentColor" />
    </svg>
  );
};

export default HomeIcon;
